export { default as Img200 } from './processed/200/ZeroDarkThirty.jpg';
export { default as Img400 } from './processed/400/ZeroDarkThirty.jpg';
export { default as Imgthumb } from './processed/thumb/ZeroDarkThirty.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/ZeroDarkThirty.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/ZeroDarkThirty.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      212,
      128,
      43
    ],
    "_population": 0
  },
  "DarkVibrant": {
    "_rgb": [
      20,
      12,
      4
    ],
    "_population": 2242,
    "_hsl": [
      0.08333333333333333,
      0.6666666666666666,
      0.047058823529411764
    ]
  },
  "Muted": {
    "_rgb": [
      100,
      140,
      113
    ],
    "_population": 9,
    "_hsl": [
      0.38749999999999996,
      0.1666666666666667,
      0.47058823529411764
    ]
  },
  "LightMuted": {
    "_rgb": [
      194,
      203,
      191
    ],
    "_population": 5003,
    "_hsl": [
      0.2916666666666668,
      0.10344827586206881,
      0.7725490196078431
    ]
  },
  "DarkMuted": {
    "_rgb": [
      65,
      88,
      72
    ],
    "_population": 2144,
    "_hsl": [
      0.38405797101449274,
      0.15032679738562094,
      0.3
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/ZeroDarkThirty.js